import React, { Component } from 'react';

class CreateStationVersionModal extends Component {
    render() {
        const {
            show,
            station,
            version,
            onClose,
            onVersionChange,
            onSubmit,
            isSubmitDisabled
        } = this.props;

        if (!show) return null;

        return (
            <div className="modal d-block" style={{ background: "rgba(0,0,0,0.5)", backdropFilter: "blur(2px)" }}>
                <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content border-0" style={{ borderRadius: "12px" }}>
                        <div className="modal-header border-0" style={{ background: "#193e6c", color: "white", borderRadius: "12px 12px 0 0" }}>
                            <h5 className="modal-title">Create New Version for {station}</h5>
                            <button type="button" className="btn-close btn-close-white" onClick={onClose}></button>
                        </div>

                        <div className="modal-body py-4">
                            <label className="form-label text-muted">Next Version</label>
                            <input
                                type="text"
                                className="form-control"
                                value={version}
                                onChange={(event) => onVersionChange(event.target.value)}
                                inputMode="decimal"
                                placeholder="Example: 2.0.1"
                                style={{ borderRadius: "6px" }}
                            />
                            <div className="form-text">Use numbers separated by decimals, for example 2.0.1.</div>
                        </div>

                        <div className="modal-footer border-0">
                            <button className="btn btn-light" onClick={onClose} style={{ borderRadius: "6px" }}>
                                Cancel
                            </button>
                            <button
                                className="btn btn-primary"
                                onClick={onSubmit}
                                disabled={isSubmitDisabled}
                                style={{ borderRadius: "6px", background: "#193e6c", border: "none" }}
                            >
                                Create
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default CreateStationVersionModal;
